import { combineReducers } from "redux";
import userReducer from "reducers/user-reducer";
import deliveryReducer from "reducers/delivery-reducer";

export default combineReducers({
  userStates: userReducer,
  deliveryStates: deliveryReducer,
});
